export default "__VITE_ASSET__BqIScyqI__"